<div echarts [options]="chartOptions" [autoResize]="true" class="donut-chart" *ngIf="chartOptions.series"
  role="img" aria-label="Donut chart" tabindex="0">
</div>
